import { SvgIcon } from '@mui/material'

export const path = `
M66.85 23.28 48.7 12.2a.917.917 0 0 0-.92-.02L29.19 22.47c-.16.09-.29.23-.37.39l-.09.9v.09l.016-.247.074-.743.071-.118L43.85 31.97c.07.04.13.11.17.19.175.35-.215.712-.551.511l-14.739-8.82.3 22.27c0 .32.17.61.44.77L47.52 57.8c.29.18.66.18.95 0l18.15-10.98a.91.91 0 0 0 .44-.78l.21-21.98c0-.32-.16-.62-.44-.79l.02.01Zm-2.6 21.15c0 .2-.11.38-.27.48l-14.71 8.67a.557.557 0 0 1-.84-.48V35.31c0-.2.1-.38.27-.48l14.8-8.96c.37-.23.85.04.85.48l-.09 18.09-.01-.01Z
`
const Block = props => <SvgIcon viewBox="0 0 96 70" {...props}><path d={path} /></SvgIcon>

export default Block
